<i18n lang="yaml">
  ru:
    ActionSidebarTypeTriggerTitle: "Тип призыва к действию"
    ActionSidebarTypeTriggerDisabled: "Данный тип призыва к действию ознакомительный. Применить его можно только на Pro-тарифе или в Демо-режиме."
    ActionSidebarTypeTriggerRedirectToPro: "Подробнее о тарифах"
    ActionSidebarTypeTriggerDisabledWhatsapp: "Требует подключения к WhatsApp."
    ActionSidebarTypeTriggerDisabledWhatsappLink: "Перейти в каналы"
  en:
    ActionSidebarTypeTriggerTitle: "Type of call for action"
    ActionSidebarTypeTriggerDisabled: "This type of call for action is familiarized. It can only be applied on a pro-tariff or in demo mode."
    ActionSidebarTypeTriggerRedirectToPro: "Read more about tariffs"
    ActionSidebarTypeTriggerDisabledWhatsapp: "This type of call requires a connection to WhatsApp."
    ActionSidebarTypeTriggerDisabledWhatsappLink: "Go to the channels"
</i18n>

<template>
  <PWAsideBodyItem
    :title="$t('ActionSidebarTypeTriggerTitle')"
  >
    <div :class="$style.actionSidebarTypeTriggerItemWrapper">
      <div
        :class="$style.actionSidebarTypeTriggerItem"
        :style="{
          gridTemplateColumns: `repeat(${types.length}, 1fr)`,
        }"
      >
        <div
          v-for="t in types"
          :key="t"
          :class="$style.actionSidebarTypeTriggerItemCtx"
        >
          <PWToggleButton
            :class="$style.actionSidebarTypeTriggerItemCtxButton"
            :is-active="computedValue === t"
            @click="computedValue = t"
          >
            <div :class="$style.actionSidebarTypeTriggerButton">
              <Component
                :is="`TypeTrigger${capitalize(t)}`"
                :class="$style.actionSidebarTypeTriggerButtonIcon"
              />
              <span :class="$style.actionSidebarTypeTriggerButtonLabel">
                {{ $t(`ActionType${capitalize(t)}`) }}
              </span>
            </div>
          </PWToggleButton>
        </div>
      </div>

      <PWInfoMessage
        v-if="!isSubscribed && computedValue !== 'message'"
      >
        <p>{{ $t('ActionSidebarTypeTriggerDisabled') }}</p><br>
        <NuxtLink
          :to="{ name: 'tariff' }"
        >
          {{ $t('ActionSidebarTypeTriggerRedirectToPro') }}
        </NuxtLink>
      </PWInfoMessage>
      <PWInfoMessage
        v-if="isWhatsappDisabled"
      >
        <p>{{ $t('ActionSidebarTypeTriggerDisabledWhatsapp') }}</p><br>
        <NuxtLink
          :to="{ name: 'settings' }"
        >
          {{ $t('ActionSidebarTypeTriggerDisabledWhatsappLink') }}
        </NuxtLink>
      </PWInfoMessage>
    </div>
  </PWAsideBodyItem>
</template>

<script>
/**
 * Utils
 */
import { capitalize } from '@/utils/capitalize'
/**
 * UI
 */
import PWAsideBodyItem from '@/components/_ui/Sidebars/PWAsideBodyItem.vue'
import PWToggleButton from '@/components/_ui/Pickers/PWToggleButton.vue'
import PWInfoMessage from '@/components/_ui/PWInfoMessage.vue'
/**
 * Static
 */
import TypeTriggerMessage from '@/assets/icons/TypeTriggerMessage.svg?inline'
import TypeTriggerChat from '@/assets/icons/TypeTriggerChat.svg?inline'
import TypeTriggerModal from '@/assets/icons/TypeTriggerModal.svg?inline'

const TYPES = [
  'message',
  'chat',
  'modal'
]

export default {
  components: {
    PWAsideBodyItem,
    PWToggleButton,
    PWInfoMessage,
    TypeTriggerMessage,
    TypeTriggerChat,
    TypeTriggerModal
  },
  props: {
    isSubscribed: {
      type: Boolean,
      default: true
    },
    isWhatsappDisabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: TYPES[0],
      validator: s => TYPES.includes(s)
    }
  },
  data: () => ({
    types: TYPES
  }),
  computed: {
    computedValue: {
      get () { return this.value },
      set (val) { this.$emit('input', val) }
    }
  },
  methods: {
    capitalize (s) {
      return capitalize(s)
    }
  }
}
</script>

<style module lang="scss">
.actionSidebarTypeTriggerButton {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 8px;
}

.actionSidebarTypeTriggerButtonIcon {
  --s: 80px;

  width: var(--s);
  height: var(--s);
}

.actionSidebarTypeTriggerItem {
  display: grid;
}

.actionSidebarTypeTriggerItemCtxButton {
  box-sizing: border-box !important;
  width: 100% !important;
  height: 100% !important;
  display: flex !important;
}

.actionSidebarTypeTriggerItemCtx {
  overflow: hidden;
  border: 1px solid var(--grey-200);
  display: grid;
  width: 100%;
  height: 156px;

  & + .actionSidebarTypeTriggerItemCtx {
    border-left-width: 0;
  }

  &:first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.actionSidebarTypeTriggerItemWrapper {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.actionSidebarTypeTriggerButtonLabel {
  font-size: 12px;
}
</style>
